// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__WaeLI","highlight":"Skeleton_highlight__DKG1E","shimmer":"Skeleton_shimmer__rjV_w"};